import { createSelector } from 'reselect';
import { flow } from 'fp-ts/function';
import { getOrEmptyString } from '@mews/fp';
import { getFilesByOwnerId } from '@mews-commander/legacy-entities/src/ducks/files';
import { getSelectedEntityId } from '../entityManagement/selectors';

export const getSelectedFile = createSelector(getFilesByOwnerId, getSelectedEntityId, (files, id) =>
    files.find((f) => f.id === id)
);

export const getSelectedFileName = flow(getSelectedFile, getOrEmptyString('name'));
